import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  public getFormattedVersion(): string {
    const versionData = environment.versionInfo;
    return versionData.major + '.' + versionData.minor + '-' + versionData.git_hash;
  }
}
